module.exports = __webpack_public_path__ + "static/media/inner_22.9ea50d21.jpg";